/** 「插入链接」贴进去的 http(s) 网址（无设备/附件标记） */

const DEVICE_OR_ATTACHMENT_LINK_TYPES = new Set(['product', 'product-category', 'attachment'])

export function isCopiedAbsoluteHref(href, linkType = '') {
  if (!/^https?:\/\//i.test(String(href || '').trim())) return false
  if (DEVICE_OR_ATTACHMENT_LINK_TYPES.has(String(linkType || '').trim())) return false
  return true
}

/** 是否为当前站点以外的 http(s) 地址 */
export function isExternalHttpHref(href, baseOrigin = typeof window !== 'undefined' ? window.location.origin : '') {
  const value = String(href || '').trim()
  if (!/^https?:\/\//i.test(value)) return false
  try {
    const url = new URL(value)
    if (!baseOrigin) return true
    return url.origin !== new URL(baseOrigin).origin
  } catch {
    return true
  }
}

export function getHttpHrefHost(href) {
  try {
    return new URL(String(href || '').trim()).host
  } catch {
    return String(href || '').trim()
  }
}
